import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

import AddAddressDetails from "./element/AddAddressDetails"
import AddCard from "./element/AddCard";
import AddNewCard from "./element/AddNewCard";
import ApproveOrderConfirm from "./element/ApproveOrderConfirm";
import AtLocation from "./element/AtLocation";
import AtLocationConfirm from "./element/AtLocationConfirm";
import BlogEight from "./element/BlogEight";
import BlogNine from "./element/BlogNine";
import BlogTen from "./element/BlogTen";
import Blogs from "./element/blogs";
import BookRequestSent from "./element/BookRequestSent";
import BookingDetailCancel from "./element/BookingDetailCancel";
import BookingDetailCancelChef from "./element/BookingDetailCancelChef";
import BookingPage1 from "./element/BookingPage1";
import BookingPage2 from "./element/BookingPage2";
import BookingPage3 from "./element/BookingPage3";
import BrowseChefMobileProfile from "./element/BrowseChefMobileProfile";
import BrowseChefProfile from "./element/BrowseChefProfile";
import Chef from "./element/Chef";
import ChefDetail from "./element/ChefDetail";
import ChefList from "./element/ChefList";
import ChefOrderDetail from "./element/ChefOrderDetail";
import Customer from "./element/Customer";
import EditChefProfile from "./element/EditChefProfile";
import FifthBlog from "./element/FifthBlog";
import FirstBlog from "./element/firstBlog";
import ForgotOTP from "./element/ForgotOTP";
import ForgotOTPVerify from "./element/ForgotOTPVerify";
import FourthBlog from "./element/FourthBlog";
import GreatJob from "./element/GreatJob";
import GroceryBill from "./element/GroceryBill";
import GroceryBillConfirm from "./element/GroceryBillConfirm";
import GroceryCamera from "./element/GroceryCamera";
import MessageDetail from "./element/MessageDetail";
import MessageList from "./element/MessageList";
import NotInterested from "./element/NotInterested";
import OTPVerify from "./element/OTPVerify";
import OrderDetail from "./element/OrderDetail";
import OrderListChef from "./element/OrderListChef";
import OrderListCustomer from "./element/OrderListCustomer";
import PageNotFound from "./element/PageNotFound";
import PaymentDetail from "./element/PaymentDetail";
import PrivacyPolicy from "./element/PrivacyPolicy";
import Profile from "./element/Profile";
import ProfileChef from "./element/CompleteChefProfile";
import Reminder from "./element/Reminder";
import ReviewToChef from "./element/ReviewToChef";
import SecondBlog from "./element/SecondBlog";
import SeventhBlog from "./element/SeventhBlog";
import SignIn from "./element/SignIn";
import SignUp from "./element/SignUp";
import SixthBlog from "./element/SeventhBlog";
import StatusManager from "./helpers/StatusManager";
import SubscriptionDetailsPage1 from "./element/SubscriptionDetailsPage1";
import SubscriptionListChef from "./element/SubscriptionListChef";
import SubscriptionMessage from "./element/subscriptionMessage";
import SubscriptionPlans from "./element/SubscriptionPlans";
import SubscriptionSummaryComponent from "./element/SubscriptionSummary";
import TermsCondition from "./element/TermsCondition";
import ThiredBlog from "./element/ThiredBlog";
import TipAmount from "./element/TipAmount";
import TipAmountSent from "./element/TipAmountSent";
import UnderReview from "./element/UnderReview";
import UpdateCard from "./element/UpdateCard";
import { isMobile } from "react-device-detect";
import signBgChef from "./images/signBgChef.jpg";
import signBgCust from "./images/signBgCust.png";

function App() {
  const paypalOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
    vault: true,
    intent: "capture",
    components: "buttons",
    currency: "USD",
    "enable-funding": "paypal",
    "disable-funding": "card,credit"
  };
  useEffect(() => {
    // Don't automatically change status on every page load
    // This was causing logout on refresh
    
    // Only update build version if needed
    // StatusManager.updateBuildVersion('1.0.2');
    
    // Don't call status changes on every page load
    // StatusManager.changeStatus('user_logged_in');
    
    // Example of proper use in a logout function:
    // const handleLogout = () => {
    //   StatusManager.changeStatus('logged_out');
    // }
  }, []);

  return (
    
    <PayPalScriptProvider options={paypalOptions}>
      <Routes>
        {/* Common */}
        <Route
          path="/under-review"
          element={<UnderReview customer={true} />}
        ></Route>
        <Route path="*" element={<PageNotFound />} />

        {/* Customer */}
        <Route path="/" element={<Customer customer={true} />}></Route>
        <Route
          path="/sign-in"
          element={<SignIn image={signBgCust} customer={true} />}
        ></Route>
        <Route
          path="/sign-up"
          element={<SignUp image={signBgCust} customer={true} />}
        ></Route>
        <Route
          path="/terms-and-conditions"
          element={<TermsCondition customer={true} />}
        ></Route>
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy customer={true} />}
        ></Route>
     
        <Route
          path="/sign-up/verify-otp"
          element={<OTPVerify image={signBgCust} customer={true} />}
        ></Route>
        <Route path="/profile" element={<Profile customer={true} />}></Route>

        <Route path="/blogs" element={<Blogs customer={true} />}></Route>
        <Route path="/blogs/on-demand-home-chefs-are-a-game-changer-for-Busy-families" element={<FirstBlog customer={true} />}></Route>
        <Route path="/blogs/home-dining-experience-with-chef-republic's-on-demand-chef-service" element={<SecondBlog customer={true} />}></Route>
        <Route path="/blogs/how-to-find-and-hire-a-personal-chef-for-your-home" element={<ThiredBlog customer={true} />}></Route>
        <Route path="/blogs/where-to-hire-a-chef-for-your-house-party" element={<FourthBlog customer={true} />}></Route>
        

        <Route path="/blogs/health_meets_gourmet:_how_private_chefs_customize_meals_for_wellness_goals" element={<FifthBlog customer={true} />}></Route>
        <Route path="/blogs/mastering_global_flavors_at_home_exploring_world_cuisines_with_a_private_chef" element={<SixthBlog customer={true} />}></Route>
        <Route path="/blogs/time_is_money_how_hiring_a_private_chef_can_be_a_smart_investment_for_busy_professionals" element={<SeventhBlog customer={true} />}></Route>
        <Route path="/blogs/cocktail_hour_drinks_and_appetizer_pairings_by_on-demand_chefs" element={<BlogEight customer={true} />}></Route>

        <Route path="/blogs/spice_it_up_exploring_exotic_spices_with_on_demand_chefs" element={<BlogNine customer={true} />}></Route>
        <Route path="/blogs/occasions_perfect_for_hiring_a_private_chef" element={<BlogTen customer={true} />}></Route>

        {/* chef */}
        <Route path="/chef" element={<Chef customer={false} />}></Route>
        <Route
          path="/chef/terms-and-conditions"
          element={<TermsCondition customer={false} />}
        ></Route>
        <Route
          path="/chef/privacy-policy"
          element={<PrivacyPolicy customer={false} />}
        ></Route>
        <Route
          path="/chef/sign-in"
          element={<SignIn image={signBgChef} customer={false} />}
        ></Route>
        <Route
          path="/chef/sign-up"
          element={<SignUp image={signBgChef} customer={false} />}
        ></Route>
        <Route
          path="/chef/sign-up/verify-otp"
          element={<OTPVerify image={signBgChef} customer={false} />}
        ></Route>
        <Route
          path="/chef/add-payment-details"
          element={<PaymentDetail image={signBgChef} customer={false} />}
        ></Route>

        {/* PHASE 2 */}
        {/* CHEF */}
        <Route
          path="/chef/complete-profile"
          element={<ProfileChef customer={false} />}
        ></Route>
        <Route
          path="/chef/profile"
          element={
            isMobile ? (
              <BrowseChefMobileProfile customer={false} />
            ) : (
              <BrowseChefProfile customer={false} />
            )
          }
        ></Route>
        <Route
          path="/chef/profile/edit"
          element={<EditChefProfile customer={false} />}
        ></Route>
        <Route
          path="/chef/order-detail"
          element={<ChefOrderDetail customer={false} />}
        ></Route>
        <Route
          path="/chef/order-list"
          element={<OrderListChef customer={false} />}
        ></Route>
        <Route
          path="/chef/grocery-bill"
          element={<GroceryBill customer={false} />}
        ></Route>
        <Route
          path="/chef/grocery-bill/confirm"
          element={<GroceryBillConfirm customer={false} />}
        ></Route>
        <Route
          path="/chef/at-location"
          element={<AtLocation customer={false} />}
        ></Route>
        <Route
          path="/chef/at-location/confirm"
          element={<AtLocationConfirm customer={false} />}
        ></Route>
        <Route
          path="/chef/great-job"
          element={<GreatJob customer={false} />}
        ></Route>
        <Route
          path="/chef/not-interested"
          element={<NotInterested customer={false} />}
        ></Route>
        <Route
          path="/chef/order-detail/confirm"
          element={<ApproveOrderConfirm customer={false} />}
        ></Route>
        <Route
          path="/chef/message-list"
          element={<MessageList customer={false} />}
        ></Route>
        <Route
          path="/chef/grocery-camera"
          element={<GroceryCamera customer={false} />}
        ></Route>
        <Route
          path="/chef/message-view"
          element={<MessageDetail customer={false} />}
        ></Route>
        <Route
          path="/chef/forgot-password"
          element={<ForgotOTP customer={false} image={signBgChef} />}
        ></Route>
        <Route
          path="/chef/forgot-password/verify"
          element={<ForgotOTPVerify customer={false} image={signBgChef} />}
        ></Route>
        <Route
          path="/chef/reminder"
          element={<Reminder customer={false} />}
        ></Route>
        <Route
          path="/chef/order/cancel"
          element={<BookingDetailCancelChef customer={false} />}
        ></Route>

        {/* Customer */}
        <Route
          path="/forgot-password"
          element={<ForgotOTP customer={true} image={signBgCust} />}
        ></Route>
        <Route
          path="/forgot-password/verify"
          element={<ForgotOTPVerify customer={true} image={signBgCust} />}
        ></Route>
        <Route
          path="/message-list"
          element={<MessageList customer={true} />}
        ></Route>
        <Route
          path="/message-view"
          element={<MessageDetail customer={true} />}
        ></Route>
        <Route path="/chef-list" element={<ChefList customer={true} />}></Route>
        <Route path="/browse-chef" element={<ChefDetail />}></Route>
        <Route
          path="/order-list"
          element={<OrderListCustomer customer={true} />}
        ></Route>
        <Route
          path="/order-detail"
          element={<OrderDetail customer={true} />}
        ></Route>
        <Route path="/booking-detail" element={<BookingPage1 />}></Route>
        <Route path="/booking-detail-1" element={<BookingPage2 />}></Route>
        <Route path="/booking-summary" element={<BookingPage3 />}></Route>
        <Route
          path="/booking-detail/confirm"
          element={<BookRequestSent customer={true} />}
        ></Route>
        <Route
          path="/booking-detail/cancel"
          element={<BookingDetailCancel customer={true} />}
        ></Route>
        <Route
          path="/update-card-details"
          element={<UpdateCard customer={true} />}
        ></Route>
        <Route
          path="/add-new-card"
          element={<AddNewCard customer={true} />}
        ></Route>
           <Route
          path="/add-card-details"
          element={<AddCard image={signBgCust} customer={true} />}
        ></Route>
        <Route
          path="/tip-amount"
          element={<TipAmount customer={true} />}
        ></Route>
        <Route
          path="/tip-amount/confirm"
          element={<TipAmountSent customer={true} />}
        ></Route>
        <Route
          path="/rate-chef"
          element={<ReviewToChef customer={true} />}
        ></Route>
        <Route
          path="/subscription-plans"
          element={<SubscriptionPlans customer={true} />}
        ></Route>
        <Route
          path="/subscription-detail"
          element={<SubscriptionDetailsPage1 customer={true} />}
        ></Route>
        <Route
          path="/add-Address-details"
          element={<AddAddressDetails image={signBgCust} customer={true} />}
        ></Route>

        <Route
          path="/subscription-summary"
          element={
            <SubscriptionSummaryComponent image={signBgCust} customer={true} />
          }
        ></Route>

        <Route
          path="/subscription-message"
          element={<SubscriptionMessage image={signBgCust} customer={true} />}
        ></Route>
        <Route
          path="chef/subscription-message"
          element={<SubscriptionMessage image={signBgCust} customer={false} />}
        ></Route>

        <Route
          path="/subscription-list"
          element={<SubscriptionListChef image={signBgCust} customer={true} />}
        ></Route>
      </Routes>
    </PayPalScriptProvider>
  );
}

export default App;
